import React from "react"

const PlasticsDescription = props => {
  return (
    <div class="field-item even" property="content:encoded">
      <p>&nbsp;</p>
      <p>Application for authorization to use plastic bags</p>
      <p>
        <strong>
          <em>What the service is about</em>
        </strong>
      </p>
      <p>
        The Law banning plastic bags and single use plastics in Rwanda provides
        for special authorization to use the plastics in certain cases. People
        requiring to use banned plastics in exceptional cases must apply for
        prior authorization to the Authority (REMA).
      </p>
      <p>
        This service allows people requiring such authorization to apply online.
      </p>
      <p>
        <strong>
          <em>Who are provided the service</em>
        </strong>
      </p>
      <p>
        People in the public or private sector with products without other
        technically viable alternative packaging to plastic bags.
      </p>
      <p>
        <strong>
          <em>Service processes (steps)</em>
        </strong>
      </p>
      <p>
        1.&nbsp;&nbsp; &nbsp;Application by the potential user with details on
        the products to be packaged, types of plastics to use, reasons for
        applying for special authorization,&nbsp;&nbsp; expected quantities,
        origin of packaging materials, possible management plan including
        collection and disposal of plastics where applicable.<br></br>
        2.&nbsp;&nbsp; &nbsp;Assessment of the application by REMA to determine
        whether the special authorization can be granted or not.<br></br>
        3.&nbsp;&nbsp; &nbsp;Response to the applicant with specific conditions,
        in case of positive consideration.<br></br>
        4.&nbsp;&nbsp; &nbsp;Follow up, reporting and approval for clearance of
        the plastics from customs in case these are imported in order to verify
        if the imported materials comply with approval conditions
      </p>
      <p>
        <strong>
          <em>Required documents( for application)</em>
        </strong>
      </p>
      <p>
        -&nbsp;&nbsp; &nbsp;Technical specifications of the products and
        packaging materials required<br></br>
        -&nbsp;&nbsp; &nbsp;Pictures of the products to be packaged<br></br>
        -&nbsp;&nbsp; &nbsp;Pictures of the packaging material, if any
      </p>
      <p>
        <strong>
          <em>Important notice to applicants (if any)</em>
        </strong>
      </p>
      <p>- REMA does not charge any fee for the authorization</p>
      <p>
        <strong>
          <em>Important links (if any)</em>
        </strong>
      </p>
      <p>
        <strong>
          <em>-</em>
        </strong>
      </p>
    </div>
  )
}

export default PlasticsDescription
